import { useDisclosure } from '@chakra-ui/react';
import React from 'react';

import { CalendarModal } from './CalendarModal';
import { DateAndVersionInput } from './DateAndVersionInput';
import { RDFV } from 'packages/dataPipeline/types/dataPipelineTypes';

/**
 * lets you choose a new version to run pipeline.
 */
export const DateAndVersionSelector = ({
  borrowerOrganizationId,
  selectedRDFV,
  setSelectedRDFV,
  allowSelection,
}: {
  selectedRDFV: RDFV | null;
  setSelectedRDFV: (pipeline: RDFV | null) => void;
  borrowerOrganizationId: string;
  allowSelection: boolean;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <DateAndVersionInput
        selectedRDFV={selectedRDFV}
        onClick={() => allowSelection && onOpen()}
      />
      {isOpen && (
        <CalendarModal
          selectedRDFV={selectedRDFV}
          setSelectedRDFV={setSelectedRDFV}
          onClose={onClose}
          borrowerOrganizationId={borrowerOrganizationId}
        />
      )}
    </>
  );
};
